import React from "react";
import PropTypes from "prop-types";

const Waves = ({ i, color, duration, frequency, origin }) => {
  return (
    <>
      <span className="wave" data-cy="Ecosystem Wave"></span>
      <style jsx>{`.wave {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  border-radius: 100%;
  border: 1px ${color} solid;
  opacity: 0;
  animation-name: wave-animation;
  animation-duration: ${duration}ms;
  animation-timing-function: linear;
  animation-delay: ${frequency * i}ms;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

@keyframes wave-animation {
  from {
    width: calc(${origin}px + 0%);
    height: calc(${origin}px + 0%);
    opacity: 1;
  }
  to {
    width: calc(0px + 100%);
    height: calc(0px + 100%);
    opacity: 0;
  }
}`}</style>
    </>
  );
};

export default Waves;

Waves.propTypes = {
  n: PropTypes.number,
  color: PropTypes.string,
};

Waves.defaultProps = {
  n: 1,
  color: "white",
};
